import { customerAddressFormFieldStyles } from "@insite/content-library/Components/CustomerAddressFormFields";
import { css } from "styled-components";
import mergeToNew from "@insite/client-framework/Common/mergeToNew";

export const customerAddressFormFieldStylesExtension = customerAddressFormFieldStyles.phoneText = mergeToNew(
    customerAddressFormFieldStyles.phoneText,
    {
        // Style the TextField wrapper itself
        css: css`
            /* Your custom CSS for the TextField container */
        `,

        // Use cssOverrides to target nested elements
        cssOverrides: {
            // Target the input element directly
            inputSelect: css`
                /* Styles for the <input> element */
                padding-left: 60px;

                &:focus {
                    padding-left: 60px;
                }
            `,

            // Target the DescriptionWrapper (contains error and hint text)
            descriptionWrapper: css`
                /* Styles for the div.DescriptionWrapper */
                position: absolute;
                inset: -10px 0 0 0;
                width: 55px;
                display: flex;
                align-items: center;
                justify-content: center;
                border-right: 1px solid #ccc;
                pointer-events: none;
                user-select: none;
                opacity: 0.8;

                span {
                    position: initial;
                }
            `,
        },
    }
);